import React from "react";
import { Glyphicon } from "react-bootstrap";
import "./MultiSearchVariableTree.scss";

export class MultiSearchVariableTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tree: props.model ? this.initTree(props.model) : [],
    };
  }

  initTree = (model) => {
    const arr = [];
    const processItem = (item, parentVariableId = null) => {
      arr.push({
        id: item.tid,
        isOpen: this.props.openItems.includes(item.tid),
        hasChildren: !!item.nodes,
        parentVariableId,
      });
      if (item.nodes) {
        item.nodes.forEach((child) => {
          processItem(child, item.tid);
        });
      }
    };
    if (model && model.length) {
      model.forEach((child) => {
        processItem(child);
      });
    }
    return arr;
  };

  checkIfOpen = (id) => {
    const { openItems } = this.props;
    return openItems.includes(id);
  };

  toggleOpen = (id) => {
    const { onOpenChange } = this.props;
    const { tree } = this.state;
    const newTree = [...tree];
    const target = newTree.find((item) => item.id === id);
    if (!target || !target.hasChildren) return;
    target.isOpen = !target.isOpen;
    onOpenChange(
      newTree.filter((item) => item.isOpen === true).map((item) => item.id)
    );
  };

  renderGroup = (children) => {
    if (!children) return null;
    return (
      <ul>
        {children.map((child, key) => (
          <li key={key}>
            <div className="MultiSearchVariableTree__row">
              <div className="MultiSearchVariableTree__triangle">
                {child.nodes && child.nodes.length > 0 && (
                  <Glyphicon
                    glyph={
                      this.checkIfOpen(child.tid) === true
                        ? "triangle-bottom"
                        : "triangle-right"
                    }
                    onClick={() => this.toggleOpen(child.tid)}
                  />
                )}
              </div>
              <div className="MultiSearchVariableTree__item">
                {this.props.itemRenderer(child)}
              </div>
            </div>
            {child.nodes &&
              this.checkIfOpen(child.tid) === true &&
              this.renderGroup(child.nodes)}
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { model } = this.props;
    return (
      <div className="MultiSearchVariableTree">{this.renderGroup(model)}</div>
    );
  }
}
